module.exports = __webpack_public_path__ + "officialStatic/img/gap-detailList1.d65c4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/gap-detailList1.png
// module id = tq5m
// module chunks = 0